const base = require('./base');
/*
 * Show global cart error message
 * @param {object} error - Error message to display
 */
function createErrorNotification(error) {
    var $errorContainer = $('.js-cart-error');
    var $existingErrorElement = $errorContainer.find('.js-cart-error-message');

    if ($existingErrorElement.length && parseInt($existingErrorElement.data('errorcode')) !== error.errorCode) {
        var $newErrorElement = $(`<div class="alert alert-danger m-cart-error js-cart-error-message" role="alert">${error.message}</div>`);
        $errorContainer.append($newErrorElement);
        window.setTimeout(() => $newErrorElement[0].remove(), 5000);
    }
}

/**
 * removes error messages and cartcontent; appends empty cart message
 */
function emptyBasket() {
    const emptyCartContent = $('#empty-cart-content-template').html();
    $('.js-cart-content').empty().append(emptyCartContent);
    $('.js-cart-error').empty();
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            createErrorNotification(data.valid);
        } else {
            emptyBasket();
        }

        if (!data.isShowButton) {
            $('.js-checkout-btn').attr('disabled', 'true');
        }
    } else {
        $('.js-checkout-btn').removeAttr('disabled');
        $('.js-cart-error').empty();
    }

    $('.js-pay-pal-checkout-btn').attr('disabled', data.isPayPalDisabled || data.valid.error);
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('body').trigger('minicart:update:qty', { qty: data.numItems, resources: data.resources }); // TODO: move me to appriate place
    $('.js-number-of-items').empty().append(data.resources.numberOfItems);
    $('.js-shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.js-grand-total-sum').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);

    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass(window.styleConstants.hideClass);
        $('.order-discount-total').empty()
            .append(`- ${data.totals.orderLevelDiscountTotal.formatted}`);
    } else {
        $('.order-discount').addClass(window.styleConstants.hideClass);
    }

    if (data.totals.giftcardsTotal.value > 0) {
        $('.js-giftcards-total').empty()
            .append(`- ${data.totals.giftcardsTotal.formatted}`);
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass(window.styleConstants.hideClass);
        $('.shipping-discount-total').empty().append(`- ${
            data.totals.shippingLevelDiscountTotal.formatted}`);
    } else {
        $('.shipping-discount').addClass(window.styleConstants.hideClass);
    }
    var items = data.items.items ? data.items.items : data.items;
    items.forEach((item) => {
        $(`.js-item-promotions-${item.UUID}`).empty().append(item.renderedPromotions);
        $(`.js-cart .js-item-total-price-${item.UUID}`).empty().append(item.priceTotal.renderedPrice);
        $(`.js-minicart-panel-yield .js-item-total-price-${item.UUID}`).empty().append(item.priceTotal.renderedPriceWithoutSubtotal);
    });
}

/**
 * re-renders the approaching discount messages
 * @param {object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    const $approachingDiscountsContainer = $('.js-approaching-discounts');
    let html = '';
    let discounts;

    if (Array.isArray(approachingDiscounts)) {
        discounts = approachingDiscounts;
    } else {
        // eslint-disable-next-line prefer-destructuring
        discounts = approachingDiscounts.discounts;
    }

    if (discounts.length > 0) {
        discounts.forEach((item) => {
            html += `<div class="alert m-cart-message" role="alert">${item.discountMsg}</div>`;
        });
    }

    $approachingDiscountsContainer.empty().append(html);
}

/**
 * Update the content of coupons-and-promos block with custom HTML
 * SFRA provide coupons and promotions in single template. By our designs it rendered
 * into different places. So as quick solution we just split fetched html without changing
 * the model.
 * @param {string} html - html string
 */
function updateCouponsAndPromos(html) {
    const fragment = document.createDocumentFragment();
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    fragment.appendChild(tmp);

    const discounts = fragment.querySelector('.js-discounts-html').firstElementChild;
    const coupons = fragment.querySelector('.js-coupons');

    $('.js-applied-coupons')
        .empty()
        .append(coupons);

    $('.js-promotions')
        .empty()
        .append(discounts);
}

/**
 * Updates the availability of a product line item
 * @param {object} config
 * @param {object} config.data - AJAX response from the server
 * @param {string} config.uuid - The uuid of the product line item to update
 */
function updateAvailability(config) {
    let uuid = config.uuid;
    let data = config.data.cartModel ? config.data.cartModel : config.data;
    let updatedProduct = config.data.product;
    let lineItem;
    let attributesHTML = '';
    let attributesShortHTML = '';

    for (let i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    const $availabilityText = $(`.js-availability-${lineItem.UUID}`);
    const $availabilityShortText = $(`.js-availability-short-${lineItem.UUID}`);

    if (updatedProduct) {
        $availabilityText.replaceWith(updatedProduct.availabilityMarkup);
    } else if (lineItem.availability) {
        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach((message) => {
                attributesHTML += `<p class="b-product_status m-${message.status}">
                    ${message.textCart || message.text}</p>`;
                if (message.message) {
                    attributesHTML += `<p class="b-product_status m-thin m-${message.status}">
                    ${message.message}</p>`;
                }
            });
        }

        if (lineItem.availability.errorMessages) {
            lineItem.availability.errorMessages.forEach((message) => {
                attributesShortHTML += `<span>${message.text}</span>`;
            });
        }

        if (lineItem.availability.messages) {
            $availabilityText.empty().html(attributesHTML);
        }
        $availabilityShortText.empty().html(attributesShortHTML);
    }

    data.items.forEach(item => {
        const $spinButton = $(`.js-line-item-qty[data-uuid="${item.UUID}"]`);

        if ($spinButton.length) {
            if (item.availability.type !== 'outofstock') {
                $spinButton.prop('disabled', false);
            } else {
                $spinButton.prop('disabled', true);
            }

            $spinButton.val(item.quantity);
            if (item.quantityOptions) {
                $spinButton.attr('aria-valuemax', item.quantityOptions.maxOrderQuantity);
            }

            if ($spinButton[0].spinbutton) {
                $spinButton[0].spinbutton.update();
            }
        }
    });
}

/**
 * Finds an element in the array that matches search parameter
 * @param {Array} array - array of items to search
 * @param {Function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    for (let i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {object} config
 * @param {object} config.data - AJAX response from the server
 * @param {string} config.uuid - The uuid of the product line item to update
 * @returns {undefined}
 */
function updateProductDetails(config) {
    const data = config.data.cartModel;
    const uuid = config.uuid;
    const newProductId = config.data.newProductId;
    const lineItem = findItem(data.items, item => item.UUID === uuid);

    if (lineItem.variationAttributes) {
        if (lineItem.SKN) {
            const colorSelector = `.js-SKN-${uuid}`;
            const newColor = data.resources.SKU + `: <strong>${lineItem.SKN}</strong>`;
            $(colorSelector).html(newColor);
        }

        const colorAttr = findItem(lineItem.variationAttributes, attr => attr.attributeId === 'color');

        if (colorAttr) {
            const colorSelector = `.js-Color-${uuid}`;
            const newColor = data.resources.color + `: <strong>${colorAttr.displayValue}</strong>`;
            $(colorSelector).html(newColor);
        }

        const sizeAttr = findItem(lineItem.variationAttributes, attr => attr.attributeId === 'size');

        if (sizeAttr) {
            const sizeSelector = `.js-Size-${uuid}`;
            const newSize = data.resources.size + `: <strong>${sizeAttr.displayValue}</strong>`;
            $(sizeSelector).html(newSize);
        }

        const imageSelector = `.js-product-info.uuid-${uuid} .js-product-image`;
        $(imageSelector).attr('src', lineItem.images.small[0].url);
        $(imageSelector).attr('alt', lineItem.images.small[0].alt);
    }

    $(`.js-line-item-title-${uuid}`).html(lineItem.productName);
    $(`.js-line-item-url-${uuid}`).attr('href', lineItem.productUrl);

    const qtySelector = `.js-line-item-qty[data-uuid="${uuid}"]`;
    $(qtySelector).attr('aria-currentValue', lineItem.quantity);
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data('pid', newProductId);

    $(`.js-remove-product[data-uuid="${uuid}"]`).data('pid', newProductId);

    const priceSelector = `.js-line-item-price-${uuid} .js-sales-price-value`;
    $(priceSelector).text(lineItem.price.sales.formatted);
    $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

    if (lineItem.price.list) {
        const listPriceSelector = `.js-line-item-price-${uuid} .js-list-price-value`;
        $(listPriceSelector).text(lineItem.price.list.formatted);
        $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
    }
}

/**
 * Update the content of bonus products block with HTML
 * @param {object} data - AJAX response from the server
 */
function updateBonusProducts(data) {
    $('.js-bonus-product').remove();
    if (data.hasBonusProduct && data.renderedBonusProducts.length) {
        const $lastProduct = $('.js-product-info:last');
        data.renderedBonusProducts.forEach((element) => {
            $lastProduct.after(element);
        });
    }
}

/**
 * Update the content of bonus products block with HTML
 * @param {object} data - AJAX response from the server
 */
function updateQuantity(data) {
    if (data.cartModel && data.cartModel.items) {
        data.cartModel.items.forEach(lineItem => {
            const $qtySelector = $(`.js-line-item-qty[data-uuid="${lineItem.UUID}"]`);
            const maxQuantity = lineItem.quantityOptions.maxOrderQuantity || lineItem.availability.ats;
            const minQuantity = lineItem.quantityOptions.minOrderQuantity || 1;
            let setQuantity = lineItem.quantity;

            if (setQuantity > maxQuantity) {
                setQuantity = maxQuantity;
            } else if (setQuantity < minQuantity) {
                setQuantity = minQuantity;
            }

            $qtySelector.attr('aria-currentValue', setQuantity);
            $qtySelector.val(setQuantity);
        });
    }
}

module.exports = function () {
    const $body = $('body');

    $body.on('basket:validate', (event, data) => validateBasket(data));
    $body.on('basket:update:discounts', (event, data) => updateApproachingDiscounts(data));
    $body.on('basket:update:promos', (event, data) => updateCouponsAndPromos(data));
    $body.on('basket:update:totals', (event, data) => updateCartTotals(data));
    $body.on('basket:update:details', (event, data) => updateProductDetails(data));
    $body.on('basket:update:availability', (event, data) => updateAvailability(data));
    $body.on('basket:update:quantity', (event, data) => updateQuantity(data));
    $body.on('basket:notify', (event, data) => createErrorNotification(data));
    $body.on('basket:empty', () => emptyBasket());
    $body.on('basket:update:bonus:products', (event, data) => updateBonusProducts(data));

    $('.js-discounts-html').remove();
    base.colorAttribute();
    base.selectAttribute();
};
